import React, { Component } from 'react';
import Slider from "react-slick";
import AiOptionButtonWrap from './AiOptionButtonWrap';
import { OPTION_URL, DYNAMIC_OPTION_URL, PRICE_URL, PRICE_URL_PROD } from '../constants';
import { crosssku, crossurl, changed } from '../reducers/reducer.js'
import { portraitReady } from './MainBodyPortrait';
import { landscapeReady } from './RightPanel';
import smoothscroll from 'smoothscroll-polyfill';
import { get_default_sku } from '../reducers/utils';
window.__forceSmoothScrollPolyfill__ = true;
smoothscroll.polyfill();

var pPos = 67
var lPos = 229
var mPos = 87
var lastsku
var inisku = ''
var loaded = false
var orientation = ''
var size = ''
var attr = ''
var fetched = []

var reflow = false;
var scrollOnce = false
var sdict = {}
var tdict = {}
var sTimer = null;
var rTimer = null;

function scrollL(downOnly) {
  if (size === 'big') {
    if (window.scrollY !== lPos - 5) {
      if (!downOnly || window.scrollY < lPos - 5)
        window.scrollTo({ top: lPos - 5, left: 0, behavior: 'smooth'})
    }
  }
  else {
    if (window.scrollY !== mPos - 5) {
      if (!downOnly || window.scrollY < mPos - 5)
        window.scrollTo({ top: mPos - 5, left: 0, behavior: 'smooth'})
    }
  }
}

function scrollP(downOnly) {
  if (window.scrollY !== pPos - 5) {
    if (!downOnly || window.scrollY < pPos - 5)
      window.scrollTo({ top: pPos - 5, left: 0, behavior: 'smooth'});
  }
}

function scrollTimer() {
  if (orientation !== 'portrait') {
    if (landscapeReady) {
      stopST();
      scrollL(false);
    }
  }
  else {
    if (portraitReady) {
      stopST()
      scrollP(false);
    }
  }
}

function stopST() {
  clearInterval(sTimer);
  sTimer = null;
}

function stopRF() {
  rTimer = null;
  reflow = false;
}

if(document.readyState === 'complete') {
	windowReady();
}
else {
	window.onload = windowReady;
}

function windowReady() {
  loaded = true;
  if (inisku !== get_default_sku())
    handleScroll(true);
  else
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
}

function handleScroll(downOnly) {
  if (attr !== 'type' || orientation === undefined)
    return
  if (lastsku !== undefined && inisku === lastsku && loaded && !scrollOnce) {
    scrollOnce = true;
    if (orientation !== 'portrait')
      scrollL(downOnly);
    else
      scrollP(downOnly);
  }
}

function NextArrow (props) {
  const { className, onClick } = props;
  return ( <div className={className + ' fa ai-next-arrow ai-fcolor-' + window.currentSite} onClick={onClick}/> ); 
}

function PrevArrow (props) {
  const { className, onClick } = props;
  return ( <div className={className + ' fa ai-prev-arrow ai-fcolor-' + window.currentSite} onClick={onClick}/> );
}

class AiOption extends Component {
  constructor(props) {
    super(props);
    if (this.props.attr === 'type') {
      if (lastsku === undefined)
        lastsku = this.props.sku
      if (inisku === '')
        inisku = this.props.inisku
      if (orientation === '')
        orientation = this.props.orientation
      if (size === '')
        size = this.props.imageSize
      if (attr === '')
        attr = 'type'
    }

    this.state = {num: this.props.optionNumber};

    if (!(this.props.attr in sdict)) {
      sdict[this.props.attr] = {infinite: false, speed: 500, dots: false, arrow: true, prevArrow: <PrevArrow />, nextArrow: <NextArrow />,
        className:'ai-options'}; //, slidesToShow: this.props.optionNumber, slidesToScroll: this.props.optionNumber,}; //, initialSlide: 0};
      var timer = null;  
      tdict[this.props.attr] = timer;
      tdict[this.props.attr + '-ct'] = 0;
    }
    
    this['slick_' + this.props.attr] = React.createRef();
    /* console.log(this['slick_' + this.props.attr])
    console.log(this['slick_' + this.props.attr].current) */

    this.initSliders = this.initSliders.bind(this);
    this.loadPrices = this.loadPrices.bind(this);

    /* var tEle = document.querySelector('#' + this.props.attr + ' .slick_track');
    var tCheck = false;
    if (tEle !== null) {
      var tStyle = tEle.style.transform;
      var tShift = tStyle.replace("translate3d(",'').replace(', 0px, 0px)','');
      tCheck = (tShift !== '0px');

      if (tCheck === true && this.props.optionNumber !== sdict[this.props.attr].slidesToShow)
        console.log(this.props.attr, tShift, tCheck, this.props.optionNumber, sdict[this.props.attr].slidesToShow)
    } */

    /* var children = this.props.children;
    let numshown = 0;
    for (let i in children) {
      if (children[i].show !== false)
        numshown += 1;
    }
    
    if (numshown > this.props.optionNumber) {
      let ct = 1;
      for (let i in children) {
        if (children[i].value === this.props.initialValue)
          break;
        if (children[i].show !== false)
          ct += 1;
      }

      let page
      if (ct % this.props.optionNumber === 0)
        page = Math.floor(ct / this.props.optionNumber) - 1
      else
        page = Math.floor(ct / this.props.optionNumber)

      var ind
      if ((page + 1) * this.props.optionNumber > numshown)
        ind = Math.max(0, numshown - this.props.optionNumber)
      else
        ind = page * this.props.optionNumber

      sdict[this.props.attr].initialSlide = ind;
      sdict[this.props.attr].numshown = numshown;
    
      console.log('AiOption constructor', this.props.attr, this.props.optionNumber, ind)
    } */

    /* if (tCheck && ((this.props.optionNumber !== sdict[this.props.attr].slidesToShow) || (sdict[this.props.attr].initialSlide !== ind))) {
      sdict[this.props.attr].slidesToScroll = this.props.optionNumber
      sdict[this.props.attr].slidesToShow = this.props.optionNumber
      sdict[this.props.attr].initialSlide = ind
      //reflow = true;

      if (sdict[this.props.attr].numshown > this.props.optionNumber && this['slick_' + this.props.attr] !== null && this['slick_' + this.props.attr].current !== null) {
        //console.log(this.props.attr, 'slickgoto', ind)
        this['slick_' + this.props.attr].current.slickGoTo(ind)
      }
      //else
      //  console.log(this.props.attr, 'slickgoto errored')
    } */
    /* else if (sdict[this.props.attr].initialSlide === undefined) {
      sdict[this.props.attr].initialSlide = ind
      tdict[this.props.attr + '-ct'] += 1;
      this.initSliders();
      if (tdict[this.props.attr] !== null) {
        console.log('cleared timer', this.props.attr)  
        clearTimeout(tdict[this.props.attr])
      }
      tdict[this.props.attr + '-ct'] += 1;
      tdict[this.props.attr] = setTimeout(this.initSliders(), 100);
    } */
    this.componentDidUpdate();
  }
  
  loadPrices() {
    if (this.props.sku === undefined) {
      return
    }
    else {
      if (this.props.sku !== lastsku) {
        /* if (this.props.attr === 'type' && this.props.sku === DEFAULT_K_SKU) {
          lastsku = this.props.sku
          inisku = this.props.sku
        } */
      }

      /* if (this.props.sku === DEFAULT_K_SKU)
        return */
        
/*       if (this.props.sku !== lastsku && this.props.sku !== inisku) {
        if (fetched.length === 3) {
          fetched = []
        }
      } */
    }
    
    if (this.props.image_base !== 'cross')
      return
      

      //console.log('ran', this.props.attr, crosssku.join(','), this.state.crossreq)

    if (crosssku === undefined || this.props.children === undefined)
      return
    
    var crossreq = crosssku.join(',') //crosssku[this.props.children[0].name] + ',' + crosssku[this.props.children[1].name]
    if (this.state.crossreq === crossreq) {
      return
    }
    /* else {
      this.setState({ crossreq: crossreq })
    } */

    /* else if (fetched.includes(this.props.attr)) {
      return
    }
    else { */
      //console.log(crossreq, this.state.crossreq, fetched, 'fetched')
    //  fetched.push(this.props.attr)
      //this.state.crossreq = crossreq
      //this.setState({ crossreq: crossreq })
    //}

    //console.log(this.props.attr, fetched)

    if (fetched.includes(this.props.attr))
      return
    else {
      fetched.push(this.props.attr)
    }

    //console.log('fetching')

    let fetchUrl = PRICE_URL
    if (window.currentEnv === 'www'){
        fetchUrl = PRICE_URL_PROD
    }
    let header = new Headers({
              'Access-Control-Allow-Origin': '*',
              'Content-Type': 'multipart/form-data'
          });
    let sentData = {
      method: 'GET',
      mode: 'cors',
      header: header,
    };
  
    fetch(fetchUrl + crosssku[this.props.children[0].name] + ',' + crosssku[this.props.children[1].name], sentData)
    .then(response => {
        if (response.ok) {
            return response.json();
        }
        else {
            this.setState({error: true})
            this.messages.show({
                severity: 'error',
                sticky: true,
                summary: 'Error loading item info: ',
                detail: 'Cannot load data'
            });
            throw new Error('Something went wrong ...');
        }
    })
    .then(json => {
      if (Object.keys(json).length === 0) {
            this.setState({error: true})
            this.messages.show({
                severity: 'error',
                sticky: true,
                summary: 'Error loading item info: ',
                detail: 'No load data'
            });
            throw new Error('Something went wrong ...');
              }
              //json = json['0']
              //console.log(json.flatMap(x => x['p']))
              //lastsku = this.props.sku
              //this.setState({ crossprice: json.flatMap(x => x['p'])}) //, crossreq: crossreq })
              this.setState({ crossprice: json.flatMap(x => x['p']), crossreq: crossreq })
              //console.log(this.state.crossprice.join())
              //console.log(crossreq, json.flatMap(x => x['p']))
  
              //state['crossprice'] = json.flatMap(x => x['p'])
              
              //this.setState({ price: json['p'],lastSku: this.props.sku })
              //this.props.onRefreshReview('refreshReview',json) //['refresh_parent'])
              //this.props.onRefreshReview('title',json.refresh_parent.title) //['refresh_parent'])
              // //console.log('json.price3', this.state.price)
      })
  }

  initSliders(transform) {
    transform = transform.replace("translate3d(",'').replace('px, 0px, 0px)','')

    if (transform % 100 !== 0)
      return

    var children = this.props.children;
    let numshown = this['slick_' + this.props.attr].current.innerSlider.state.slideCount;
    
      let ct = 1;
      for (let i in children) {
        if (children[i].value === this.props.initialValue)
          break;
        if (children[i].show !== false)
          ct += 1;
      }

      let page
      if (ct % this.props.optionNumber === 0)
        page = Math.floor(ct / this.props.optionNumber) - 1
      else
        page = Math.floor(ct / this.props.optionNumber)

      var ind
      if ((page + 1) * this.props.optionNumber > numshown)
        ind = Math.max(0, numshown - this.props.optionNumber)
      else
        ind = page * this.props.optionNumber

      /* let trackShift = parseInt(transform / 100)
      if (((this['slick_' + this.props.attr].current.innerSlider.state.currentSlide + this.props.optionNumber + trackShift) <= numshown) && trackShift < 0)
        trackShift = 0
      let slickLower = (trackShift !== 0)?trackShift - this['slick_' + this.props.attr].current.innerSlider.state.currentSlide : this['slick_' + this.props.attr].current.innerSlider.state.currentSlide + 1
      let slickUpper = (trackShift !== 0)?trackShift - this['slick_' + this.props.attr].current.innerSlider.state.currentSlide + this.props.optionNumber - 1 : this['slick_' + this.props.attr].current.innerSlider.state.currentSlide + this.props.optionNumber
 */
      //if(['cec','headc','rsetc'].includes(this.props.attr))
      //console.log(this.props.attr, 'ct='+ct,'currSlide='+this['slick_' + this.props.attr].current.innerSlider.state.currentSlide,'optNum='+this.props.optionNumber,'numshown='+numshown,'lowerbound='+(slickLower),'upperbound='+(slickUpper),'inRange=',(ct >= slickLower && ct <= slickUpper))

      /* if(['cec','headc','rsetc'].includes(this.props.attr))
      console.log(this.props.attr, this.state.num, this.props.optionNumber, ct >= slickLower && ct <= slickUpper) */
      //if (!(ct >= slickLower && ct <= slickUpper) || true) {
        if (reflow && this['slick_' + this.props.attr].current.innerSlider.state.currentSlide !== ind) {
          //if(['cec','headc','rsetc'].includes(this.props.attr))
          //console.log(this.props.attr,'set currentslide','from='+this['slick_' + this.props.attr].current.innerSlider.state.currentSlide,'to='+ind)
          //this['slick_' + this.props.attr].current.innerSlider.state.currentSlide = ind
          this['slick_' + this.props.attr].current.slickGoTo(ind)
        }
      //}
      //this['slick_' + this.props.attr].current.innerSlider.state.currentSlide = ind
    //this['slick_' + this.props.attr].current.slickGoTo(ind)
  }

  componentDidMount() {
    this['slick_' + this.props.attr] = React.createRef();
    this.loadPrices();
  }

  componentDidUpdate() {
    //console.log(lastsku, this.props.sku)
    if (lastsku === get_default_sku())
      lastsku = this.props.sku
    /* if (this.props.attr === 'cross1')
    console.log(this.props.attr, this.props.sku) */
    /* if(this.props.image_base == 'cross')
      console.log(this.props.sku, this.state.crossreq, this.state.crossprice) */
    if (lastsku !== this.props.sku && fetched.length === 3) {
      lastsku = this.props.sku
      fetched = []
    }

    this.loadPrices();

    if (this.props.sku === get_default_sku()) {
      scrollOnce = false
    }

    if (!loaded)
      return
    if (orientation !== this.props.orientation && this.props.orientation !== undefined) {
      orientation = this.props.orientation;      
      if (orientation !== 'portrait' && sTimer === null)
        sTimer = setInterval(scrollTimer, 100);
      else if (sTimer === null)
        sTimer = setInterval(scrollTimer, 100);

      //reflow = true;

      //console.log('initsliders - orientation', this.props.attr, this.props.optionNumber)
      /* if (tdict[this.props.attr] !== null) {
        console.log('cleared timer', this.props.attr)  
        clearTimeout(tdict[this.props.attr])
      } */
      /* tdict[this.props.attr + '-ct'] += 1;
      tdict[this.props.attr] = setTimeout(this.initSliders(), 100); */
    }
    else if (size !== this.props.imageSize && this.props.imageSize !== undefined) {
      size = this.props.imageSize;
      if (orientation !== 'portrait' && sTimer === null)
        sTimer = setInterval(scrollTimer, 100);
      else if (sTimer === null)
        sTimer = setInterval(scrollTimer, 100);

      //reflow = true;

      //console.log('initsliders - imageSize', this.props.attr, this.props.optionNumber)
      /* if (tdict[this.props.attr] !== null) {
        console.log('cleared timer', this.props.attr)  
        clearTimeout(tdict[this.props.attr])
      } */
      /* tdict[this.props.attr + '-ct'] += 1;
      tdict[this.props.attr] = setTimeout(this.initSliders(), 100); */
    }
    if (this.state.num !== this.props.optionNumber || reflow) {
      //this.state.num = this.props.optionNumber;
      this.setState({num: this.props.optionNumber})
      reflow = false;
      clearTimeout(rTimer)
      rTimer = setTimeout(stopRF, 500)
    }
  }

  render() {
    //console.log('AiOption rendered')
    let settings = sdict[this.props.attr];
    settings.slidesToShow = this.props.optionNumber;
    settings.slidesToScroll = this.props.optionNumber;

    var children = this.props.children;
    let numshown = 0;
    for (let i in children) {
      if (children[i].show !== false)
        numshown += 1;
    }
    
    if (numshown > this.props.optionNumber) {
      let ct = 1;
      for (let i in children) {
        if (children[i].value === this.props.initialValue)
          break;
        if (children[i].show !== false)
          ct += 1;
      }

      let page
      if (ct % this.props.optionNumber === 0)
        page = Math.floor(ct / this.props.optionNumber) - 1
      else
        page = Math.floor(ct / this.props.optionNumber)

      var ind
      if ((page + 1) * this.props.optionNumber > numshown)
        ind = Math.max(0, numshown - this.props.optionNumber)
      else
        ind = page * this.props.optionNumber

        settings.initialSlide = ind;
/*         if (this['slick_' + this.props.attr].current) {
          let trackShift = parseInt(this['slick_' + this.props.attr].current.innerSlider.state.trackStyle.transform.replace("translate3d(",'').replace('px, 0px, 0px)','')/100)
          if(this.props.attr=='cec')
          console.log(trackShift)
          let slickShift = 0 //(this['slick_' + this.props.attr].current.innerSlider.state.currentSlide + this.props.optionNumber) > numshown ? this['slick_' + this.props.attr].current.innerSlider.state.currentSlide + this.props.optionNumber - numshown : 0
          let slickLower = this['slick_' + this.props.attr].current.innerSlider.state.currentSlide + 1 - slickShift
          let slickUpper = this['slick_' + this.props.attr].current.innerSlider.state.currentSlide + this.props.optionNumber - slickShift
          if(this.props.attr === 'cec')
          console.log('ct='+ct,'currSlide='+this['slick_' + this.props.attr].current.innerSlider.state.currentSlide,'init='+ind,'optNum='+this.props.optionNumber,'lowerbound='+(slickLower),'upperbound='+(slickUpper),'inRange='+(ct > slickLower && ct <= slickUpper))
        //this['slick_' + this.props.attr].current.innerSlider.state.currentSlide = ind
        //this['slick_' + this.props.attr].current.slickGoTo(ind)
      }
 */    
    }

    /* if (settings.initialSlide !== undefined && settings.numshown > this.props.optionNumber && this['slick_' + this.props.attr] !== null && this['slick_' + this.props.attr].current !== null) {
      //console.log('slickgoto', this.props.attr, settings.initialSlide)
      this['slick_' + this.props.attr].current.slickGoTo(settings.initialSlide)
    } */
    //else
    //  console.log('nogo', this.props.attr, settings.numshown, this.props.optionNumber, this['slick_' + this.props.attr], this['slick_' + this.props.attr].current)

    var optionSize = this.props.optionSize + 'px';
    let ctwfix = {'0.33':'33', '0.5':'33', '1':'75', '0.75':'75', '1.5':'150'}
    let rows = [];
    let dynamic = ['ctw', 'shank', 'rset', 'bset']
    let ctw2 = ['HOV', 'HECU', 'HPS']
    var css = this.props.css;
    for (let i in children) {
      let image_url;
      let image_url2;
      let name = children[i].name
      if (dynamic.indexOf(this.props.image_base) !== -1) {
        image_url = DYNAMIC_OPTION_URL  
        if (this.props.image_base === 'shank')
          image_url = this.props.ds + '-' + ctwfix[this.props.dctw] + '-' + this.props.head + '-' + children[i].image
        else if (this.props.image_base === 'bset')
          image_url += 'baside4-' + children[i].image
        else if (this.props.image_base === 'rset')
          image_url += 'side-' +  this.props.sh + '-' + children[i].image     

        if (this.props.image_base === 'shank') {
          image_url2 = OPTION_URL + 'large/shank/' + image_url
          image_url = OPTION_URL + 'small/shank/' + image_url
        }
        else if (this.props.image_base === 'ctw') {
          image_url2 = OPTION_URL + 'large/' + this.props.image_base + '/' + this.props.ds.toLowerCase() + '/' + children[i].image
          image_url = OPTION_URL + 'small/' + this.props.image_base + '/' + this.props.ds.toLowerCase() + '/' + children[i].image
          if (this.props.sh.substring(0,1) === 'B') {
            if (ctw2.includes(this.props.ds))
              name = children[i].name8
            else
              name = children[i].name7
          }
          else if (this.props.sh.substring(0,1) === 'E' || this.props.sh === 'P8') {
            if (this.props.ds === 'HPS')
              name = children[i].name6
            else if (ctw2.includes(this.props.ds))
              name = children[i].name4
            else
              name = children[i].name3
          }
          else {
            if (this.props.ds === 'HPS')
              name = children[i].name5
            else if (ctw2.includes(this.props.ds))
              name = children[i].name2
            else
              name = children[i].name
          }
        }
      }
      else if (this.props.image_base === 'cross') {
        /* if (this.state.crossprice === undefined)
          name = ''
        else if (children[i].value !== 0) {
          //name = '$' + this.state.crossprice[children[i].value-1]
          name = <div>$<div>{this.state.crossprice[children[i].value-1]}</div></div>
        } */

        if (children[i].value === 0)
          css = "cross0"
        else if ((this.props.sh === 'R6' && this.props.attr === 'cross2' && children[i].value === 1) || (this.props.sh === 'P3' && this.props.attr === 'cross2' && children[i].value === 1)
            || (this.props.sh === 'P8' && this.props.attr === 'cross2' && children[i].value === 2) || (this.props.sh === 'B3' && this.props.attr === 'cross3' && children[i].value === 2)
            || (this.props.sh === 'B4' && this.props.attr === 'cross3' && children[i].value === 2) || (this.props.sh === 'R1' && this.props.attr === 'cross1' && children[i].value === 1)
            || (this.props.sh === 'R5' && this.props.attr === 'cross1' && children[i].value === 1) || (this.props.sh === 'R6' && this.props.attr === 'cross1' && children[i].value === 1)
            || (this.props.sh === 'R11' && this.props.attr === 'cross1' && children[i].value === 2) || (this.props.sh === 'E2' && this.props.attr === 'cross2' && children[i].value === 1)
            || (this.props.sh === 'E3' && this.props.attr === 'cross2' && children[i].value === 2) || (this.props.sh === 'B2' && this.props.attr === 'cross2' && children[i].value === 1))
          css = "crossmax"
        else
          css = "cross"
       // console.log('children',children)
       // console.log('crossurl',crossurl)
        switch (this.props.attr) {
          case 'cross1':
            if (this.state.crossprice === '' || this.state.crossprice === undefined)
              name = ''
            else if (children[i].value !== 0)
              name = <div>$<div>{this.state.crossprice[children[i].value-1]}</div></div>
            image_url2 = children[i].value === 0 ? OPTION_URL + 'large/cross/none.jpg' : (crossurl[0][children[i].value] + '&s=200')
            image_url = children[i].value === 0 ? OPTION_URL + 'small/cross/none.jpg' : (crossurl[0][children[i].value] + '&s=200')
            break;
          case 'cross2':
            if (this.state.crossprice === '' || this.state.crossprice === undefined)
              name = ''
            else if (children[i].value !== 0)
              name = <div>$<div>{this.state.crossprice[children[i].value-1]}</div></div>  //+1
            image_url2 = children[i].value === 0 ? OPTION_URL + 'large/cross/none.jpg' : (crossurl[1][children[i].value] + '&s=200')
            image_url = children[i].value === 0 ? OPTION_URL + 'small/cross/none.jpg' : (crossurl[1][children[i].value] + '&s=200')
            break;
          case 'cross3':
            if (this.state.crossprice === '' || this.state.crossprice === undefined)
              name = ''
            else if (children[i].value !== 0)
              name = <div>$<div>{this.state.crossprice[children[i].value-1]}</div></div>  //+3
            image_url2 = children[i].value === 0 ? OPTION_URL + 'large/cross/none.jpg' : (crossurl[2][children[i].value] + '&s=200')
            image_url = children[i].value === 0 ? OPTION_URL + 'small/cross/none.jpg' : (crossurl[2][children[i].value] + '&s=200')
            break;
          default:
            break;
        }
      }
      else {
        if (this.props.attr === 'sh' && changed && children[i].show) {
          //if (window.testAB ==='B' ) 
          
            image_url2 = OPTION_URL + 'large/' + this.props.image_base + '/' + children[i].image.split('.')[0] +  '.jpg?v=1'
            image_url = OPTION_URL + 'small/' + this.props.image_base + '/' + children[i].image.split('.')[0] + '.jpg?v=1'
         
          /*else{
            image_url2 = OPTION_URL + 'large/' + this.props.image_base + '/' + children[i].image.split('.')[0] + '/' + this.props.ds + '.jpg'
            image_url = OPTION_URL + 'small/' + this.props.image_base + '/' + children[i].image.split('.')[0] + '/' + this.props.ds + '.jpg'
            }*/
        }
        else {
          image_url = OPTION_URL  
          image_url2 = OPTION_URL  
          image_url += 'small/'
          image_url2 += 'large/'
          image_url += this.props.image_base + '/'
          image_url2 += this.props.image_base + '/'
          if (this.props.image_postfix !== '') {
            if (this.props.image_postfix === 'ds') {
              image_url += this.props.ds + '/'
              image_url2 += this.props.ds + '/'
            }
            else {
              image_url += this.props.image_postfix + '/'
              image_url2 += this.props.image_postfix + '/'
            }
          }
          else if (this.props.sh === 'R12' && this.props.attr === 'headc') {
            image_url += 'HPS/'
            image_url2 += 'HPS/'
          }
          image_url += children[i].image
          image_url2 += children[i].image
        }
      }

      var active_view = false
      if (this.props.hasOwnProperty('active_view'))
        active_view = children[i].active_view
      let prefix = undefined
      if (children[i].quality !== '')
        prefix = children[i].quality
      let name_top = ''

      if (children[i].hasOwnProperty('month'))
        name_top = children[i].month.substring(0,3).toUpperCase()

      let show = true
      if (children[i].hasOwnProperty('show') && children[i].show === false)
        show = false
     
      if (show)
        rows.push(<AiOptionButtonWrap
          name={name} 
          nameTop={name_top} 
          namePrefix={prefix} 
          attr={this.props.attr} 
          css={css}
          value={children[i].value} 
          show={show} 
          active_view ={active_view}
          key={this.props.attr +'-'+i.toString()} 
          style={{ float:'left',height:optionSize}}
          image={image_url}
          image2={image_url2}
          options_all={this.props.options_all}
          optionSize={optionSize}/>
        );
    }
    let hr_not_last = [];
    if (this.props.last === 'false')
      hr_not_last.push(<div className='ai-textinput-hr' key={'hr-' + this.props.attr}/>)
    var maxSliderSize = (this.props.optionNumber * this.props.optionSize+1) + 'px';
    let fcolor = 'ai-color-' + window.currentSite + ' ai-option-title'
    let bcolor = this.props.optionName.replace('name','titlediv')
    let name = this.props.name.toUpperCase()
    if (this.props.image_base === 'cross') {
      var cat;
      if (this.props.attr === 'cross1')
        cat = crossurl[0][0]
      else if (this.props.attr === 'cross2')
        cat = crossurl[1][0]
      else
        cat = crossurl[2][0]
      
      switch (cat) {
        case 'R':
          name = 'RING'
          break;
        case 'P':
          name = 'PENDANT'
          break;
        case 'E':
          name = 'EARRINGS'
          break;
        case 'B':
          name = 'BRACELET'
          break;
        default:
          break;
      }
    }
    if (['headc','rsetc'].includes(this.props.attr) && (this.props.dict['headc'] === '0' || this.props.dict['rsetc'] === '0'))
      name = 'ACCENT COLOR'
    else if (this.props.attr === 'cec' && this.props.dict['cec2'] !== '0')
      name = 'STONE COLOR 1'
    else if (this.props.attr === 'hmet' && this.props.dict['rmet'] !== '0' && this.props.hmet === 'S')
      name = 'METAL'
    else if (this.props.attr === 'rmet' && (this.props.dict['hmet'] === '0' || this.props.dict['rmet'] === '0'))
      name = 'METAL'
    else if (this.props.sh.substring(0,1) === 'B') {
      if (this.props.attr === 'ds')
        name = (this.props.dict['cec2'] !== '0' ? '' : 'PRIMARY ') + 'STONE SHAPE'
      else if (this.props.attr === 'dctw')
        name = (this.props.dict['cec2'] !== '0' ? '' : 'PRIMARY ') + 'STONE SIZE'
      else if (this.props.attr === 'cec')
        name = 'PRIMARY STONE COLOR'
    }

    /* if (this.props.attr === 'sh')
      console.log(rows.flatMap(x => x['key'])) */

    if (this.props.type === '0')
      name = 'SELECT YOUR ' + name + ' AND START CUSTOMIZING'
    
    if (rows.length <= this.props.optionNumber)
      return (<div id={this.props.attr} style={{width: maxSliderSize, marginLeft: '30px'}}
               className={'ai-option-box' + this.props.optionName + this.props.cssep}>
                <div className={bcolor}><div className='ai-option-title-left'></div>
                 <div className={fcolor + this.props.optionName.replace('name','titleline')}>
                  {name}</div></div>{rows}<div style={{clear:'both'}}/>{hr_not_last}</div>);
    else
      return (<div id={this.props.attr} onClick={handleScroll(false)} style={{width: maxSliderSize, marginLeft: '30px'}}
               className={'ai-option-box' + this.props.optionName + this.props.cssep}><div><div className='ai-option-title-left'>
                  </div><div className={fcolor}>{name}</div></div><Slider ref={this['slick_' + this.props.attr]} {...settings} onReInit={() => {
      if (this['slick_' + this.props.attr].current && this['slick_' + this.props.attr].current.innerSlider.state.trackStyle.transform !== undefined)
      {this.initSliders(this['slick_' + this.props.attr].current.innerSlider.state.trackStyle.transform);}
                  }}
                       style={{width: maxSliderSize, height: optionSize}}>{rows}</Slider>{hr_not_last}</div>);
  }
}
export default AiOption;


// WEBPACK FOOTER //
// ./src/layout/AiOption.js